import { AwsWeb } from '@packages/types';

export const WEB_AWS_CONFIG: AwsWeb = {
  API: {
    endpoints: [
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}freely-upsell-service`,
        name: 'Upsell',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-claims-service/claims`,
        name: 'Claim',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-uploader-service/presignedpost`,
        name: 'FileUpload',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-user-service`,
        name: 'User',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-basecover-service/basecover`,
        name: 'BaseCover',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-websocket-service/wstoken`,
        name: 'Heartbeat',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-payments-service/guest/payments`,
        name: 'Payment',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-quotes-service`,
        name: 'Quote',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/global-trips-service`,
        name: 'Trip',
      },
      {
        endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-messaging-service/notification`,
        name: 'Notification',
      },
    ],
  },
  aws_appsync_authenticationType: 'AWS_LAMBDA',
  aws_appsync_graphqlEndpoint: import.meta.env.VITE_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  aws_appsync_region: 'ap-southeast-2',
  aws_cognito_identity_pool_id: import.meta.env.VITE_AWS_COGNITO_IDENTITY_POOL_ID,
  aws_cognito_region: 'ap-southeast-2',
  aws_project_region: 'ap-southeast-2',
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
} as const;

export const WEB_OPEN_APIS = {
  endpoints: [
    {
      endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/freely-quotes-service`,
      name: 'Quote',
    },
    {
      endpoint: `${import.meta.env.VITE_AWS_REST_API_BASE_URL}/global-trips-service`,
      name: 'Trip',
    },
  ],
} as const;
